<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background Overlay -->
    <div class="fixed inset-0 bg-[#363738] dark:bg-[#3333331f] bg-opacity-25 transition-opacity backdrop-blur-sm"></div>
    <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class="fixed inset-y-0 right-0 flex max-w-full pl-4 sm:pl-8">
                <div class="w-screen max-w-xl px-4 py-4">
                    <!-- Modal Content -->
                    <div class="flex flex-col px-4 py-4 overflow-y-auto">
                        <div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
                            <!-- Background Overlay -->
                            <div
                                class="fixed inset-0 bg-[#D4D7DE] dark:bg-[#3333331f] bg-opacity-25 transition-opacity backdrop-blur-sm">
                            </div>
                            <div class="fixed inset-0 overflow-hidden">
                                <div class="absolute inset-0 overflow-hidden">
                                    <div class="fixed inset-y-0 right-0 flex max-w-full pl-4 sm:pl-8">
                                        <div class="w-screen max-w-lg px-4 py-4">
                                            <!-- Modal Container -->
                                            <div
                                                class="flex h-full flex-col overflow-y-hidden bg-white dark:bg-zinc-950 border-zinc-950/10 dark:border-white/10 shadow-xl rounded-lg">
                                                <!-- Header Section -->
                                                <div
                                                    class="flex justify-between items-center py-3 px-4 bg-primary dark:bg-white/5">
                                                    <div class="flex flex-1 items-center gap-2">
                                                        <div class="size-10 rounded-full overflow-hidden bg-gray-100">
                                                            <img class="size-11 rounded-full" src="" alt="Company Logo">
                                                        </div>
                                                        <div>
                                                            <dt
                                                                class="flex items-center text-sm/6 font-medium text-white dark:text-gray-300">
                                                            <dd
                                                                class="mt-1 text-sm text-white font-bold leading-tight sm:col-span-2 sm:mt-0">
                                                                {{companyDetail.CompanyName || 'N/A'}}
                                                            </dd>
                                                            <dd
                                                                class="mt-1 text-white/80 text-sm leading-tight sm:col-span-2  first:sm:mt-0">
                                                                {{companyDetail.status || 'N/A'}}
                                                            </dd>
                                                        </div>
                                                    </div>
                                                    <div class="flex justify-end">
                                                        <button type="button" (click)="onCloseModal()"
                                                            class="rounded-lg p-1 text-left text-base/6 font-medium text-white sm:text-sm/5 hover:bg-white/5">
                                                            <span class="sr-only">Close panel</span>
                                                            <svg class="size-5" xmlns="http://www.w3.org/2000/svg"
                                                                fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                                                stroke="currentColor" aria-hidden="true">
                                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                                    d="M6 18L18 6M6 6l12 12" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>

                                                <!-- Modal Content -->
                                                <div class="flex flex-col px-4 py-4 overflow-y-auto">
                                                    <div>

                                                        <div class="border-gray-100 dark:border-gray-800">
                                                            <dl class="divide-y divide-gray-100 dark:divide-gray-800">




                                                              
                                                                <!-- User Name -->
                                                                <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        User Name</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{companyDetail?.user?.name || 'N/A'}}
                                                                    </dd>
                                                                </div>

                                                                  <!-- User email -->
                                                                <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        User Email</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{companyDetail?.user?.email || 'N/A'}}
                                                                    </dd>
                                                                </div>

                                                              
                                                                <!-- Address -->
                                                                <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        Address</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{companyDetail?.CompanyAddr?.Line1 || 'N/A'}}
                                                                    </dd>
                                                                </div>


                                                                <!-- City -->
                                                                <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        City</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{companyDetail?.CompanyAddr?.City || 'N/A'}}
                                                                    </dd>
                                                                </div>

                                                                <!-- Country -->
                                                                <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        Country</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{companyDetail?.CompanyAddr?.Country || 'N/A'}}
                                                                    </dd>
                                                                </div>

                                                                <!-- Postal Codete -->
                                                                <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        Postal Code</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{companyDetail.CompanyAddr?.PostalCode ||
                                                                        'N/A'}}
                                                                    </dd>
                                                                </div>


                                                                <!-- Request Time -->
                                                                <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        Created At</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{(companyDetail.createdAt | date: 'MM/DD/YYYY')
                                                                        || 'N/A'}}
                                                                    </dd>
                                                                </div>


                                                                <!-- updated at -->
                                                                    <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        Updated At</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{(companyDetail.updatedAt | date: 'MM/DD/YYYY')
                                                                        || 'N/A'}}
                                                                    </dd>
                                                                </div>

                                                                <!-- webURL -->
                                                                <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        Reference URL</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{companyDetail.reference?.url || 'N/A'}}
                                                                    </dd>
                                                                </div>


                                                                <!-- Reference -->
                                                                <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        Reference Id</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{companyDetail.reference?.id || 'N/A'}}
                                                                    </dd>
                                                                </div>

                                                                  <!-- Reference Name -->

                                                                <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        Reference Name</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{companyDetail.reference?.name || 'N/A'}}
                                                                    </dd>
                                                                </div>

                                                                 <!-- Reference Name -->

                                                                <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        Active</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{companyDetail.Active}}
                                                                    </dd>
                                                                </div>



                                                                  <div
                                                                    class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt
                                                                        class="text-sm/6 font-medium text-gray-900 dark:text-gray-300">
                                                                        Status</dt>
                                                                    <dd
                                                                        class="mt-1 text-sm/6 text-gray-700 dark:text-gray-400 sm:col-span-2 sm:mt-0">
                                                                        {{companyDetail.status | capitalize}}
                                                                    </dd>
                                                                </div>



                                                            </dl>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>